"use client";
import Link from "next/link";
import { useEffect, useState } from "react";
export default function Parktimings() {
  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch("/api/tickettimebanners");
        if (res.ok) {
          const data = await res.json();
          setImage1(data.image1 || "");
          setImage2(data.image2 || "");
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchImages();
  }, []);

  return (
    <>
      <section
        id="about"
        className="about-section fix section-padding scrollSpySection pb-0"
      >
        <div className="container">
          <div className="about-wrapper">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <Link href="/timings-ticket-pricings">
                  <img
                    src={image1 || "/assets/img/parktimings.png"}
                    alt="Park Timings"
                    width={600}
                    height={343}
                  />
                </Link>
              </div>

              <div className="col-lg-6">
                <Link href="/ticket">
                  <img
                    src={image2 || "/assets/img/entryticket.png"}
                    alt="Entry Ticket"
                    width={600}
                    height={343}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
